



















import { Vue, Component, Prop } from "vue-property-decorator";

import IconExpandMore from "@/components/icons/IconExpandMore.vue";

@Component({ components: { IconExpandMore } })
export default class Schedule extends Vue {
  opened = false;

  @Prop({ type: String, default: "" })
  schedule!: string;

  get shortened() {
    const array = this.schedule.split(", п");
    return array[0] || "";
  }
}
